import { RootState } from '@/store/store';
import { ModuleTree } from 'vuex';
import { courseModuleActions } from '../course-module/course-module.actions';
import { courseModuleMutations } from '../course-module/course-module.mutations';
import { courseModuleState } from '../course-module/course-module.state';
import { courseModuleGetters } from './course-module.getter';

export default {
  namespaced: true,
  state: courseModuleState,
  getters: courseModuleGetters,
  actions: courseModuleActions,
  mutations: courseModuleMutations
} as ModuleTree<RootState>;
